import refParcellaireApi from '@/api/ref-parcellaire.api'

const getDefaultState = () => {
  return {
    resumeParcellaire: {},
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    resumeParcellaire (state) {
      return state.resumeParcellaire
    }
  },

  mutations: {
    UPDATE_RESUME_PARCELLAIRE (state, resumeParcellaire) {
      state.resumeParcellaire = resumeParcellaire
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    getResumeParcellaire ({ commit, rootGetters }, {anneeRecolte, codeTypeCulture}) {
      const numtiers = rootGetters['adherent/numtiers']
      return refParcellaireApi.getResumeParcellaire(numtiers, anneeRecolte, codeTypeCulture)
        .then(response => {
          commit('UPDATE_RESUME_PARCELLAIRE', response)
        })
    },
    reset ({ commit }) {
      commit('RESET')
    },
  }
}

export default module
